import {
  REDUCER_NAMES_HISTORY_KEG_FILLS_CONTRACTEE,
} from '../../../constants'


import {
  createAllShipmentsHistorySelectorsHof,
} from './shipmentsHistoryHigherOrderFunctions'

export const {
  getProp,
  getPropOfAll,
  getEntireSlice,
  getAreAnyItemsInACertainStatus,
} = createAllShipmentsHistorySelectorsHof(REDUCER_NAMES_HISTORY_KEG_FILLS_CONTRACTEE)
